import React from 'react';
import './Button.css';

const Button = (props) => {
    return ( 
        <button> 
            <h6 className='button_text'>{props.text}</h6>
        </button>
     );
}
 
export default Button;